<template>
  <div class="w-full space-y-4">
    <div class="bg-white rounded-lg flex flex-col p-6 shadow-md space-y-4">
      <h1 class="font-medium text-sm lg:text-xl">Knowledge Base</h1>
      <p>
        Users can review the LSM Stringer Handbook that is embedded below. If
        you would like to have a copy for offline use, feel free to download the
        <a
          href="https://lsm-mms.s3.amazonaws.com/docs/guidebooks/LSM-Stringer-Guidebook-v2_1.pdf"
          target="_blank"
          class="text-blue-600"
          >latest version</a
        >
        of it locally. Additional resources are planned for the knowledge base
        in the near future.
      </p>
    </div>
    <object
      data="https://lsm-mms.s3.amazonaws.com/docs/guidebooks/LSM-Stringer-Guidebook-v2_1.pdf"
      type="application/pdf"
      width="100%"
      height="800px"
      class="rounded-lg"
    >
      <p>
        It appears you don't have a PDF plugin for this browser. No biggie...
        you can
        <a
          href="https://lsm-mms.s3.amazonaws.com/docs/guidebooks/LSM-Stringer-Guidebook-v2_1.pdf"
          >click here to download the PDF file.</a
        >
      </p>
    </object>
  </div>
</template>

<script>
import * as Config from "@/config";

export default {
  name: "StringerKnowledgeBase",
  data() {
    return {};
  },
  created() {},

  methods: {}
};
</script>

<style scoped></style>
